import SlackErrorService from "../services/SlackErrorService";

const handleErrorApi = async (error, type) => {
    const currentUrl = window.location.href;

    if (type === 'unhandledrejection') {
        return SlackErrorService.sendError({
            name: error.type,
            fileName: 'Nema ove informacije',
            stack: error.reason.stack,
            message: error.reason.message,
            currentUrl: currentUrl
        });
    } else if (type === 'error') {
        return SlackErrorService.sendError({
            name: error.error.message,
            fileName: error.filename,
            stack: error.error.stack,
            message: error.message,
            currentUrl: currentUrl
        });
    }
}

export {
    handleErrorApi
};
